import React from 'react';
import ProjectContent from '../components/ProjectContent';

const Stoinks = () => <ProjectContent projectName='Stoinks'/>;

export default Stoinks;